<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="subject">{{subject.name}}</template> - 出纳日记账 </span>
		</div>
		<div class="margin-right-left margin-top no-print">
			<account-date-choose v-model="accountDate"/>
			<span class="range-sep">至</span>
			<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px; vertical-align: middle;"></DatePicker>
			<div class="float-right">
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<div class="print-header">
					<div class="print-title"><template v-if="subject">{{subject.name}}</template>出纳日记账</div>
					<div class="print-sub">
						<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
						<span>期间：{{printPeriod}}</span>
						<span>单位：元</span>
					</div>
				</div>
				<table class="cus-table">
					<thead class="header">
					<tr>
						<td width="100">日期</td>
						<td width="100">凭证字号</td>
						<td>摘要</td>
						<td width="120">收入(借方)</td>
						<td width="120">支出(贷方)</td>
						<td width="60">方向</td>
						<td width="120">余额</td>
					</tr>
					</thead>
					<tbody>
					<template v-for="(row,idx) in displayRows">
						<tr :key="idx" :class="{'day-total':row.dayTotal,'sum-total':row.sumRow}">
							<td>{{row.voucherDate}}</td>
							<td>
								<router-link v-if="row.voucherId" :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">{{row.word}}-{{row.code}}</router-link>
							</td>
							<td>{{row.summary}}</td>
							<td class="text-right">{{row.debitAmount|numFormat}}</td>
							<td class="text-right">{{row.creditAmount|numFormat}}</td>
							<td class="text-center" :class="{'abnormal-balance':isAbnormalBalance(row)}">{{row.balanceDirection}}</td>
							<td class="text-right" :class="{'abnormal-balance':isAbnormalBalance(row)}">{{row.balance|numFormat}}</td>
						</tr>
					</template>
					<tr v-if="!displayRows.length">
						<td colspan="7" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200" class="no-print">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	//出纳科目根编码：新准则 1001库存现金/1002银行存款/1011零余额账户用款额度/1012,1021其他货币资金；旧准则 101现金/102银行存款/109其他货币资金
	const CASHIER_CODE_PREFIX = ['1001', '1002', '1011', '1012', '1021', '101', '102', '109'];

	export default {
		name: 'CashierJournal',
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				datalist: [],
				subjectId: null,
				accountDate: null,
				endMonth: null,
				subject: null
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			printPeriod() {
				if (!this.accountDate) {
					return '';
				}
				let s = moment(this.accountDate).format('YYYY年MM月');
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
				}
				return s;
			},
			displayRows() {
				if (!this.datalist.length) {
					return [];
				}
				let rows = [];
				let details = [];
				this.datalist.forEach(item => {
					if (item.voucherId) {
						details.push(item);
					} else if (item.summary === '期初余额') {
						rows.push(item);
					}
				});
				//按日分组并插入本日合计
				let dayMap = new Map();
				details.forEach(item => {
					let day = item.voucherDate ? moment(item.voucherDate).format('YYYY-MM-DD') : '';
					if (!dayMap.has(day)) {
						dayMap.set(day, []);
					}
					dayMap.get(day).push(item);
				});
				dayMap.forEach(list => {
					let dayDebit = 0;
					let dayCredit = 0;
					list.forEach(item => {
						dayDebit += Number(item.debitAmount || 0);
						dayCredit += Number(item.creditAmount || 0);
						rows.push(item);
					});
					let last = list[list.length - 1];
					rows.push({
						voucherDate: last.voucherDate,
						summary: '本日合计',
						debitAmount: dayDebit,
						creditAmount: dayCredit,
						balanceDirection: last.balanceDirection,
						balance: last.balance,
						dayTotal: true
					});
				});
				//期末追加 本期合计/本年累计
				this.datalist.forEach(item => {
					if (!item.voucherId && item.summary !== '期初余额') {
						rows.push(Object.assign({sumRow: true}, item));
					}
				});
				return rows;
			}
		},
		watch: {
			subject() {
				this.loadList();
			},
			accountDate() {
				this.loadSubject();
			},
			endMonth() {
				this.loadList();
			}
		},
		methods: {
			isCashier(subject) {
				return subject.code && CASHIER_CODE_PREFIX.some(prefix => subject.code.indexOf(prefix) === 0);
			},
			loadSubject() {
				this.datalist = [];
				this.subject = null;
				this.$api.accountbook.loadSubject({accountDate: this.accountDate}).then(({data}) => {
					let cashierSubjects = data.filter(s => this.isCashier(s));
					this.$set(this.param, "datas", cashierSubjects);
					if (cashierSubjects.length) {
						this.subjectId = cashierSubjects[0].id;
						this.subject = cashierSubjects[0];
					} else {
						this.subjectId = null;
					}
				});
			},
			loadList() {
				if (!this.subject) {
					return;
				}
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					subjectId: this.subjectId,
					subjectCode: this.subject.code
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadVoucherDetails(params).then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			subjectSelect(node) {
				this.subject = node;
			},
			//余额方向与科目默认方向相反且余额非零时视为异常（出纳科目出现贷方余额即透支），红字提示
			isAbnormalBalance(item) {
				return !!(this.subject && this.subject.balanceDirection
					&& item.balanceDirection && item.balanceDirection !== '平'
					&& item.balanceDirection !== this.subject.balanceDirection
					&& Number(item.balance) !== 0);
			},
			doExport() {
				if (!this.displayRows.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let name = this.subject ? this.subject.name : '';
				let headers = ['日期', '凭证字号', '摘要', '收入(借方)', '支出(贷方)', '方向', '余额'];
				let rows = this.displayRows.map(item => [
					item.voucherDate ? moment(item.voucherDate).format('YYYY-MM-DD') : '',
					item.word && item.code ? item.word + '-' + item.code : '',
					item.summary,
					item.debitAmount, item.creditAmount, item.balanceDirection, item.balance
				]);
				exportCsv('出纳日记账-' + name + (this.accountDate ? '-' + moment(this.accountDate).format('YYYYMM') : '') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			}
		}
	};
</script>

<style lang="less" scoped>
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.day-total {
		background-color: #f8f8f8;
		font-weight: bold;
	}
	.sum-total {
		font-weight: bold;
	}
	.abnormal-balance {
		color: #f56c6c;
		font-weight: bold;
	}
</style>
